import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created");
      navigate("/", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F4F2] px-6" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
      <div className="w-full max-w-sm">
        <Link to="/login" className="text-[11px] uppercase tracking-[0.25em] text-neutral-500 hover:text-black" data-testid="register-login-link" style={{ fontFamily: '"IBM Plex Mono", monospace' }}>
          ← Back to sign in
        </Link>
        <h2 className="mt-4 text-3xl tracking-tight" style={{ fontFamily: '"Work Sans", sans-serif' }}>
          Create your account.
        </h2>
        <p className="mt-1 text-sm text-neutral-600">Start mapping your organization.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="register-form">
          <div className="space-y-1.5">
            <Label className="text-[11px] uppercase tracking-wider text-neutral-500">Name</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} required className="rounded-none border-neutral-300" data-testid="register-name-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[11px] uppercase tracking-wider text-neutral-500">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-none border-neutral-300" data-testid="register-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[11px] uppercase tracking-wider text-neutral-500">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="rounded-none border-neutral-300" data-testid="register-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[11px] uppercase tracking-wider text-neutral-500">Confirm password</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="rounded-none border-neutral-300" data-testid="register-password-confirm-input" />
          </div>
          <Button type="submit" disabled={loading} className="h-11 w-full rounded-none bg-[#002FA7] text-white hover:bg-[#001F70]" data-testid="register-submit-button">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
      </div>
    </div>
  );
}
